import { render, staticRenderFns } from "./LeaveSheet.vue?vue&type=template&id=a4fb38a8"
import script from "./LeaveSheet.vue?vue&type=script&lang=js"
export * from "./LeaveSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports